module.exports = __webpack_public_path__ + "05_short_black.d1e495cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/05_short_black.png
// module id = LqVk
// module chunks = 0